import type { AuditLogApiResponse, MappedAuditLog } from '@/types/audit-logs'
import { mapZone } from '@/utils/mappers/ZoneMap'

const mapAuditLogs = (response: AuditLogApiResponse): MappedAuditLog => {
	const {
		id, zoneAuditLogId, zone, removeServiceLocations, addServiceLocations, approved
	} = response
	return {
		id: zoneAuditLogId || id || 0,
		zone: mapZone(zone),
		serviceLocations: removeServiceLocations?.map(serviceLocation => {
			return {
				id: serviceLocation.serviceLocationId,
				address: serviceLocation.address?.address1,
				removedFrom: serviceLocation.zoneName,
				addedTo: addServiceLocations?.find(addServiceLocation => addServiceLocation.serviceLocationId === serviceLocation.serviceLocationId)?.zoneName || 'No Zone'
			}
		}) || [],
		approved
	}
}

export { mapAuditLogs }
